const cmsUsersEndpoints = {
  base: "/v1/cms/users",
  list: ({ page = 1, limit = 20, search = "" } = {}) => {
    const params = new URLSearchParams();
    params.set("page", String(page || 1));
    params.set("limit", String(limit || 20));
    if (String(search || "").trim()) {
      params.set("search", String(search).trim());
    }
    return `/v1/cms/users?${params.toString()}`;
  },
  byId: (id) => `/v1/cms/users/${encodeURIComponent(String(id || ""))}`,
  adminRole: (id) =>
    `/v1/cms/users/${encodeURIComponent(String(id || ""))}/admin-role`,
  admins: ({ tourId = "", page = 1, limit = 20, search = "" } = {}) => {
    const params = new URLSearchParams();
    if (String(tourId || "").trim()) {
      params.set("tourId", String(tourId).trim());
    }
    params.set("page", String(page || 1));
    params.set("limit", String(limit || 20));
    if (String(search || "").trim()) {
      params.set("search", String(search).trim());
    }
    return `/v1/cms/users/admins?${params.toString()}`;
  },
  adminTour: (id) =>
    `/v1/cms/users/${encodeURIComponent(String(id || ""))}/admin-tour`,
};

export default cmsUsersEndpoints;
